import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import '../../../NarrativePage/Filter/Filter.scss';


export const DistributionTabChooser = ({onChange, selected = []}) => {
  const { t } = useTranslation();

  const caseOptions = [
    {value: 'summary', label: t('Summary')},
    {value: 'narratives', label: t('Narratives')},
    {value: 'bubbleChart', label: t('Publications distribution')},
    {value: 'evolutionViews', label: t('Evolution: Views')},
    {value: 'evolutionShare', label: t('Evolution: Percentage')},
    {value: 'evolutionReactions', label: t('Evolution: Engagement')},
    {value: 'evolutionMessages', label: t('Evolution: Publications')},
    {value: 'sentimentMessages', label: t('Sentiment: Publications')},
    {value: 'sentimentViews', label: t('Sentiment: Views')},
    {value: 'sentimentReactions', label: t('Sentiment: Reactions')},
  ];

  let distributionTabOptions = caseOptions;
 
  const handleSelect = () => {
    if (distributionTabOptions.length !== selected.length) {
      onChange(distributionTabOptions.map(item => item.value))
    } else {
      onChange([])
    }
  }

  return(
    <div className='chooser'>
      <div className='control' onClick={() => handleSelect()}>{distributionTabOptions?.length === selected.length ? t('Deselect all') : t('Select all')}</div>
      <ul>
        {distributionTabOptions?.map(item => {
          return(
            <li key={item.value}>
              <input 
                id={`distribTab_${item.value}`}
                type='checkbox'
                checked={selected.includes(item.value)}
                onChange={() => {
                  if (selected.includes(item.value)) {
                    onChange(selected.filter(v => v !== item.value)) 
                  } else {
                    onChange([...selected, item.value]) 
                  }
                }}
              />
              <label htmlFor={`distribTab_${item.value}`}>{item.label}</label>
            </li>
          )
        })}
        
      </ul>
    </div>
  )
}
